var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuplicate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 14c0-0.552-0.447-1-1-1s-1 0.448-1 1v3h-3c-0.553 0-1 0.448-1 1s0.447 1 1 1h3v3c0 0.552 0.447 1 1 1s1-0.448 1-1v-3h3c0.553 0 1-0.448 1-1s-0.447-1-1-1h-3V14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 27c0 0.553-0.447 1-1 1s-1-0.447-1-1V2H5C4.447 2 4 1.553 4 1s0.447-1 1-1h25c1.104 0 2 0.896 2 2V27z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30c0 1.104 0.896 2 2 2h3c0.553 0 1-0.447 1-1s-0.447-1-1-1H2V6h24v24H9c-0.553 0-1 0.447-1 1s0.447 1 1 1h17c1.104 0 2-0.896 2-2V6c0-1.104-0.896-2-2-2H2C0.896 4 0 4.896 0 6V30z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/Duplicate.20839bc9.svg";
export { ForwardRef as ReactComponent };